import React, { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import api from "../lib/api";
import { useAuth } from "../lib/auth";
import { toast } from "sonner";

export default function AuthCallback() {
  const location = useLocation();
  const nav = useNavigate();
  const { setUserAfterOAuth } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) {
      nav("/admin/login");
      return;
    }
    const sessionId = decodeURIComponent(m[1]);

    (async () => {
      try {
        const res = await api.post("/auth/session", { session_id: sessionId });
        window.history.replaceState({}, "", "/");
        setUserAfterOAuth(res.data.user);
        const role = res.data.user.role;
        if (["PLATFORM_ADMIN", "CONTENT_ADMIN"].includes(role)) {
          nav("/admin", { state: { user: res.data.user }, replace: true });
        } else if (["PSYCHOLOGIST", "PSYCHIATRIST"].includes(role)) {
          nav("/clinician", { state: { user: res.data.user }, replace: true });
        } else if (role === "RESPONDENT") {
          // Respondents landing via Google go straight to consent — the
          // consent page will forward them to voice/questionnaires if they
          // have already accepted the current version.
          nav("/consent", { state: { user: res.data.user }, replace: true });
        } else {
          toast.info("Signed in — contact your admin for role assignment");
          nav("/", { replace: true });
        }
      } catch (e) {
        toast.error("Sign-in failed");
        nav("/admin/login", { replace: true });
      }
    })();
  }, [location.hash, nav, setUserAfterOAuth]);

  return (
    <div className="min-h-screen bg-background flex items-center justify-center">
      <div className="text-muted-foreground">Completing sign-in…</div>
    </div>
  );
}
